import useSnapshot from "./useSnapshot";

export default function useDocument(query) {
	return useSnapshot(query, true);
}
